import React, { useState } from "react"
import Link from "gatsby-link"
import { FormattedMessage } from "react-intl"
import { NavigationDataItem } from "../../utils/extract-navigation"
import formatPagePath from "../../utils/format-page-path"

interface MenuItemProps {
  item: NavigationDataItem
  clickCallback: (e: React.MouseEvent<HTMLElement>) => void
}

const MenuItem: React.FC<MenuItemProps> = ({ item, clickCallback }) => {
  const [expanded, setExpanded] = useState(false)
  const expandable = !!item.items

  return (
    <div className={`c-menu__item${expanded ? " -expanded" : ""}`}>
      <Link to={formatPagePath(item.path)} onClick={clickCallback}>
        <FormattedMessage id={"navigation." + item.key} />
      </Link>
      {expandable && (
        <button
          className="c-menu__item-expand"
          onClick={() => setExpanded(!expanded)}
          aria-controls={`menu-item-${item.key}`}
          aria-expanded={expanded}
        >
          <span className="u-visually-hidden">
            {expanded ? "Collapse" : "Expand"}
          </span>
        </button>
      )}
      {expanded && (
        <div id={`menu-item-${item.key}`} className="c-menu__children">
          {item.items.map(item => {
            return (
              <MenuItem
                key={item.key}
                item={item}
                clickCallback={clickCallback}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
export default MenuItem
